import React from 'react';

import { InsuranceDetails } from 'Api/insurance';
import { WrapLgMarginBottom } from 'App/global-style';
import { Markdown } from 'Components/Markdown';
import { AgreementCode } from 'Constants/agreementCodes.constants';
import {
  isElectricScooterInsurance,
  isPersonalAkaInsurance,
} from 'Utils/insuranceTypes/insuranceTypes.utils';
import { LinkRenderer } from 'Utils/markdown.utils';
import { getAppText } from 'Utils/text';
import { getPartnerPhoneNumberVariable } from './emailCancellationForm.helpers';

export interface EmailCancellationInfoProps {
  insuranceProduct: InsuranceDetails['insuranceProduct'];
  agreementProduct: AgreementCode;
}

export const EmailCancellationInfo = ({
  insuranceProduct,
  agreementProduct,
}: EmailCancellationInfoProps) => {
  const phoneNumberVariables = getPartnerPhoneNumberVariable(agreementProduct);

  const renderEmailCancellationInfo = () => {
    if (isPersonalAkaInsurance(insuranceProduct)) {
      return (
        <Markdown components={{ a: LinkRenderer }}>
          {getAppText('cancelInsurance.manualText.aka.markdown', {
            insert: phoneNumberVariables,
          })}
        </Markdown>
      );
    }

    if (isElectricScooterInsurance(insuranceProduct)) {
      return (
        <Markdown>
          {getAppText('cancelInsurance.manualText.electricScooter.markdown', {
            insert: phoneNumberVariables,
          })}
        </Markdown>
      );
    }

    return (
      <Markdown>
        {getAppText('cancelInsurance.manualMessage.infoText.markdown', {
          insert: phoneNumberVariables,
        })}
      </Markdown>
    );
  };

  return (
    <WrapLgMarginBottom>{renderEmailCancellationInfo()}</WrapLgMarginBottom>
  );
};
